export const LOAD_DATASOURCES_REQUEST = 'LOAD_DATASOURCES_REQUEST';
export const LOAD_DATASOURCES_SUCCESS = 'LOAD_DATASOURCES_SUCCESS';
export const LOAD_DATASOURCES_FAILURE = 'LOAD_DATASOURCES_FAILURE';

export const CONNECT_DATASOURCE_REQUEST = 'CONNECT_DATASOURCE_REQUEST';
export const CONNECT_DATASOURCE_SUCCESS = 'CONNECT_DATASOURCE_SUCCESS';
export const CONNECT_DATASOURCE_FAILURE = 'CONNECT_DATASOURCE_FAILURE';

export const DISCONNECT_DATASOURCE_REQUEST = 'DISCONNECT_DATASOURCE_REQUEST';
export const DISCONNECT_DATASOURCE_SUCCESS = 'DISCONNECT_DATASOURCE_SUCCESS';
export const DISCONNECT_DATASOURCE_FAILURE = 'DISCONNECT_DATASOURCE_FAILURE';

export const LOAD_DATASOURCES_CATEGORIES_REQUEST = 'LOAD_DATASOURCES_CATEGORIES_REQUEST';
export const LOAD_DATASOURCES_CATEGORIES_SUCCESS = 'LOAD_DATASOURCES_CATEGORIES_SUCCESS';
export const LOAD_DATASOURCES_CATEGORIES_FAILURE = 'LOAD_DATASOURCES_CATEGORIES_FAILURE';

export const LOAD_DATASOURCES_TYPES_REQUEST = 'LOAD_DATASOURCES_TYPES_REQUEST';
export const LOAD_DATASOURCES_TYPES_SUCCESS = 'LOAD_DATASOURCES_TYPES_SUCCESS';
export const LOAD_DATASOURCES_TYPES_FAILURE = 'LOAD_DATASOURCES_TYPES_FAILURE';